package dev.lingvo.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.shared.ProjectAccentKey
import dev.lingvo.shared.ProjectIconKey
import dev.lingvo.site.api.Async
import dev.lingvo.site.ds.ALL_ICONS
import dev.lingvo.site.ds.AsyncFailureState
import dev.lingvo.site.ds.DsGalleryStyle
import dev.lingvo.site.ds.DsGlyphGridStyle
import dev.lingvo.site.ds.DsGroundStyle
import dev.lingvo.site.ds.DsHeroHeaderStyle
import dev.lingvo.site.ds.DsHeroStyle
import dev.lingvo.site.ds.DsIconCellStyle
import dev.lingvo.site.ds.DsIconSheetStyle
import dev.lingvo.site.ds.DsIdentityGridStyle
import dev.lingvo.site.ds.DsPageStyle
import dev.lingvo.site.ds.DsSectionStyle
import dev.lingvo.site.ds.DsSpecimenGridStyle
import dev.lingvo.site.ds.ErrorState
import dev.lingvo.site.ds.GlyphMosaic
import dev.lingvo.site.ds.IconSize
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LArrowRightIcon
import dev.lingvo.site.ds.LAsyncContent
import dev.lingvo.site.ds.LAvatar
import dev.lingvo.site.ds.LAvatarSize
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBadgeVariant
import dev.lingvo.site.ds.LBreadcrumbItem
import dev.lingvo.site.ds.LBreadcrumbs
import dev.lingvo.site.ds.LBulkActionBar
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonSize
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LCard
import dev.lingvo.site.ds.LCheckCheckIcon
import dev.lingvo.site.ds.LCheckbox
import dev.lingvo.site.ds.LChip
import dev.lingvo.site.ds.LChord
import dev.lingvo.site.ds.LCircleAlertIcon
import dev.lingvo.site.ds.LClockIcon
import dev.lingvo.site.ds.LCodeBlock
import dev.lingvo.site.ds.LCodeLanguage
import dev.lingvo.site.ds.LCoinsIcon
import dev.lingvo.site.ds.LConfirmDialog
import dev.lingvo.site.ds.LColorField
import dev.lingvo.site.ds.LNumberField
import dev.lingvo.site.ds.LCopyField
import dev.lingvo.site.ds.LDateRange
import dev.lingvo.site.ds.LDiffText
import dev.lingvo.site.ds.LDisclosure
import dev.lingvo.site.ds.LDivider
import dev.lingvo.site.ds.LDownloadIcon
import dev.lingvo.site.ds.LEmptyState
import dev.lingvo.site.ds.LEmptyStateIcon
import dev.lingvo.site.ds.LFileIcon
import dev.lingvo.site.ds.LFilterBar
import dev.lingvo.site.ds.LFilterField
import dev.lingvo.site.ds.LFilterIcon
import dev.lingvo.site.ds.LGlobeIcon
import dev.lingvo.site.ds.LGridIcon
import dev.lingvo.site.ds.LIconBadge
import dev.lingvo.site.ds.LIconButton
import dev.lingvo.site.ds.LKbd
import dev.lingvo.site.ds.LKeyValueKind
import dev.lingvo.site.ds.LKeyValueLink
import dev.lingvo.site.ds.LKeyValueRow
import dev.lingvo.site.ds.LLanguagesIcon
import dev.lingvo.site.ds.LListChecksIcon
import dev.lingvo.site.ds.LMenu
import dev.lingvo.site.ds.LMenuEntry
import dev.lingvo.site.ds.LMenuGroup
import dev.lingvo.site.ds.LMenuItem
import dev.lingvo.site.ds.LMenuPlacement
import dev.lingvo.site.ds.LMenuSeparator
import dev.lingvo.site.ds.LModal
import dev.lingvo.site.ds.LModalSize
import dev.lingvo.site.ds.LMoonIcon
import dev.lingvo.site.ds.LPageState
import dev.lingvo.site.ds.LPagination
import dev.lingvo.site.ds.LPanelLeftIcon
import dev.lingvo.site.ds.LPlusIcon
import dev.lingvo.site.ds.LProgressBar
import dev.lingvo.site.ds.LProgressCounts
import dev.lingvo.site.ds.LProgressRing
import dev.lingvo.site.ds.LProgressRingSize
import dev.lingvo.site.ds.LProjectMark
import dev.lingvo.site.ds.LRefreshIcon
import dev.lingvo.site.ds.LSearchField
import dev.lingvo.site.ds.LSearchXIcon
import dev.lingvo.site.ds.LSectionHeading
import dev.lingvo.site.ds.LSectionTitle
import dev.lingvo.site.ds.LSegmented
import dev.lingvo.site.ds.LSegmentedOption
import dev.lingvo.site.ds.LSelect
import dev.lingvo.site.ds.LSelectOption
import dev.lingvo.site.ds.LSettingsIcon
import dev.lingvo.site.ds.LShieldIcon
import dev.lingvo.site.ds.LSkeleton
import dev.lingvo.site.ds.LSkeletonShape
import dev.lingvo.site.ds.LSmartphoneIcon
import dev.lingvo.site.ds.LSpinner
import dev.lingvo.site.ds.LSpinnerSize
import dev.lingvo.site.ds.LSplitButton
import dev.lingvo.site.ds.LSquarePenIcon
import dev.lingvo.site.ds.LStatDelta
import dev.lingvo.site.ds.LStatDirection
import dev.lingvo.site.ds.LStatRow
import dev.lingvo.site.ds.LStatRowItem
import dev.lingvo.site.ds.LStatTile
import dev.lingvo.site.ds.LStep
import dev.lingvo.site.ds.LIconAction
import dev.lingvo.site.ds.LReorderList
import dev.lingvo.site.ds.LGripVerticalIcon
import dev.lingvo.site.ds.LSteps
import dev.lingvo.site.ds.LSunIcon
import dev.lingvo.site.ds.LSwitch
import dev.lingvo.site.ds.LTab
import dev.lingvo.site.ds.LTable
import dev.lingvo.site.ds.LTableAlign
import dev.lingvo.site.ds.LTableBody
import dev.lingvo.site.ds.LTableCell
import dev.lingvo.site.ds.LTableHead
import dev.lingvo.site.ds.LTableHeaderCell
import dev.lingvo.site.ds.LTableHeaderScope
import dev.lingvo.site.ds.LTableRow
import dev.lingvo.site.ds.LTableSelectAllHeaderCell
import dev.lingvo.site.ds.LTableSelection
import dev.lingvo.site.ds.LTabs
import dev.lingvo.site.ds.LTagIcon
import dev.lingvo.site.ds.LTagsIcon
import dev.lingvo.site.ds.LTaskProgress
import dev.lingvo.site.ds.LTextArea
import dev.lingvo.site.ds.LTextField
import dev.lingvo.site.ds.LToast
import dev.lingvo.site.ds.LToastVariant
import dev.lingvo.site.ds.LToggleChip
import dev.lingvo.site.ds.LTooltip
import dev.lingvo.site.ds.LUndoIcon
import dev.lingvo.site.ds.LUsersIcon
import dev.lingvo.site.ds.LWandSparklesIcon
import dev.lingvo.site.ds.LZapIcon
import dev.lingvo.site.ds.LoadingState
import dev.lingvo.site.ds.PageHeader
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.ToastHost
import dev.lingvo.site.ds.ToastState
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.chordKeys
import dev.lingvo.site.ds.commandChordKeys
import dev.lingvo.site.ds.formatCount
import dev.lingvo.site.ds.iconSize
import dev.lingvo.site.ds.monoFont
import dev.lingvo.site.ds.rememberToasts
import dev.lingvo.site.ds.toSitePalette
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tPlural
import dev.lingvo.site.i18n.tf
import dev.lingvo.site.i18n.tr
import kotlinx.browser.document
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * The design system, drawn once each.
 *
 * The sheet is exhaustive on purpose: `DesignSystemGalleryTest` counts the distinct `data-lucide`
 * names this page renders against `ALL_ICONS`, so a glyph added to the kit and never drawn here
 * fails the build rather than quietly leaving the sheet a subset of the system it documents.
 *
 * Specimen copy — project names, translations, the sentences a demo toast carries — is **fixture
 * data and is deliberately not translated**, the same decision `toastCopy` records at the end of
 * this file: they are chosen to show what a component is *for*, and a translator handed them would
 * be editing strings no reader will ever meet. Every string the components themselves render as
 * their own copy — a section title, a field's refusal, a dialog's button — goes through the
 * catalogue like anywhere else.
 */
@Page("/ds")
@Composable
fun DesignSystemPage() {
    var colorMode by ColorMode.currentState
    val gallery = remember { GalleryState() }
    val toasts = rememberToasts()
    val notify: Notify = { message, variant ->
        toasts.show(message, variant)
    }

    // Every other route in `pages/` sets one. This was the only page whose tab was titled by
    // whatever the shell happened to default to, which makes it unfindable among fifteen open tabs
    // of the same product.
    LaunchedEffect(Unit) {
        document.title = tr("ds.design_system_lingvo", "Design system — Lingvo")
    }

    Div(DsPageStyle.toModifier().toAttrs()) {
        Column(Modifier.fillMaxWidth().maxWidth(88.cssRem).gap(Space.XL).styleModifier { property("margin", "0 auto") }) {
            Hero(colorMode) { colorMode = colorMode.opposite }
            // A landmark, like every other route has. The gallery was the one page rendering its
            // whole body inside a bare `Div`, so a screen reader had no "skip to content" target and
            // `smoke-site.mjs` — which asserts a `main` exists, because a page without one is
            // usually a page that failed to render — reported it as blank while it was fine.
            Main(DsGalleryStyle.toModifier().toAttrs()) {
                Sections(gallery, toasts, notify)
            }
        }
        ToastHost(state = toasts)
    }
}

@Composable
private fun Hero(colorMode: ColorMode, onToggleTheme: () -> Unit) {
    Div(DsHeroStyle.toModifier().toAttrs()) {
        GlyphMosaic(animated = true)
        Column(Modifier.position(Position.Relative).zIndex(1).gap(Space.XXL)) {
            PageHeader(
                title = t("ds.lingvo_in_every_state", "Lingvo, in every state"),
                subtitle = t(
                    "ds.a_working_specimen_sheet_for_the",
                    "A working specimen sheet for the moments between source copy and a trusted release.",
                ),
                modifier = DsHeroHeaderStyle.toModifier(),
                mark = { LIconBadge { LLanguagesIcon(Modifier.iconSize(IconSize.XXL)) } },
                // "Workspace" pointed at `/`, which is the marketing home page — the trail named a
                // destination the link does not lead to, in the one component whose whole purpose
                // is telling a reader where they are.
                eyebrow = {
                    LBreadcrumbs(
                        listOf(
                            LBreadcrumbItem("Lingvo", "/"), // i18n-ignore
                            LBreadcrumbItem(t("ds.design_system", "Design system"), "/ds"),
                            LBreadcrumbItem(t("ds.component_gallery", "Component gallery")),
                        ),
                    )
                },
                status = { LBadge(t("ds.system_01", "SYSTEM / 01"), variant = LBadgeVariant.ACCENT) },
                meta = {
                    HeroFact(tf("ds.count_glyphs", "{count} glyphs", "count" to formatCount(ALL_ICONS.size)))
                    HeroFact(
                        tf(
                            "ds.count_project_marks",
                            "{count} project marks",
                            "count" to formatCount(ProjectIconKey.entries.size * ProjectAccentKey.entries.size),
                        ),
                    )
                    HeroFact(
                        tf(
                            "ds.count_empty_states",
                            "{count} empty states",
                            "count" to formatCount(LEmptyStateIcon.entries.size),
                        ),
                    )
                },
                actions = {
                    LIconAction(
                        label = if (colorMode.isDark) {
                            t("ds.switch_to_light_theme", "Switch to light theme")
                        } else {
                            t("ds.switch_to_dark_theme", "Switch to dark theme")
                        },
                        onClick = onToggleTheme,
                        variant = LButtonVariant.SECONDARY,
                    ) { if (colorMode.isDark) LSunIcon() else LMoonIcon() }
                },
            )
        }
    }
}

/**
 * Every section of the sheet, numbered from its own position.
 *
 * The numbers used to be written into each call — `"01"`, `"02"` — which is a list maintained by
 * hand next to a list the compiler already has. Inserting the icon sheet at the front would have
 * renumbered eleven call sites, and the first one anybody forgot would have given the page two
 * sections called 07.
 *
 * **The order is load-bearing.** `DsGalleryStyle` packs `row dense` at MD, so a full-width section
 * that cannot fit beside a half-width one leaves a hole the packer backfills with the *next*
 * single-column card. The sheet read 02, 04, 03 down the page for exactly that reason, and twice
 * more below it (07, 10, 08, 09 and 11, 13, 12, 14) — the one thing on a card that claims to be an
 * ordinal was the one thing the layout did not honour. Single-width sections therefore come in
 * pairs before every wide one, which costs nothing and makes source order equal reading order. A
 * lone section at the end is fine: a half-empty last row is not a hole.
 */
@Composable
private fun Sections(state: GalleryState, toasts: ToastState, notify: Notify) {
    val sections = listOf(
        GallerySection(
            title = t("ds.icons", "Icons"),
            description = t(
                "ds.every_glyph_at_every_rung_on",
                "Every glyph, at every rung, on both grounds it has to survive.",
            ),
            icon = { LGridIcon() },
            modifier = wideModifier(),
        ) { IconSheet() },
        GallerySection(
            title = t("ds.page_chrome", "Page chrome"),
            description = t(
                "ds.what_a_page_says_about_itself",
                "What a page says about itself before the body says anything.",
            ),
            icon = { LPanelLeftIcon() },
            modifier = wideModifier(),
        ) { PageChrome(notify) },
        GallerySection(
            title = t("ds.actions", "Actions"),
            description = t("ds.every_hierarchy_density_and_control_state", "Every hierarchy, density, and control state."),
            icon = { LZapIcon() },
        ) { Actions(state, notify) },
        GallerySection(
            title = t("ds.signals", "Signals"),
            description = t("ds.status_risk_and_release_confidence", "Status, risk, and release confidence."),
            icon = { LCircleAlertIcon() },
        ) { Signals(state, notify) },
        GallerySection(
            title = t("ds.forms", "Forms"),
            description = t(
                "ds.editable_invalid_and_unavailable_localization_da",
                "Editable, invalid, and unavailable localization data.",
            ),
            icon = { LSquarePenIcon() },
            modifier = wideModifier(),
        ) { Forms(state, notify) },
        GallerySection(
            title = t("ds.loading_notices", "Loading & notices"),
            description = t("ds.placeholders_activity_and_transient_feedback", "Placeholders, activity, and transient feedback."),
            icon = { LClockIcon() },
        ) { LoadingAndNotices(state, toasts, notify) },
        GallerySection(
            title = t("ds.content", "Content"),
            description = t("ds.compact_identity_and_metadata_primitives", "Compact identity and metadata primitives."),
            icon = { LFileIcon() },
        ) { ContentPrimitives(state, notify) },
        GallerySection(
            title = t("ds.navigation_filters", "Navigation & filters"),
            description = t("ds.keyboard_ready_movement_through_dense_work", "Keyboard-ready movement through dense work."),
            icon = { LFilterIcon() },
        ) { Navigation(state, notify) },
        GallerySection(
            title = t("ds.overlays", "Overlays"),
            description = t("ds.menus_explanations_and_focused_decisions", "Menus, explanations, and focused decisions."),
            icon = { LSettingsIcon() },
            modifier = Modifier.styleModifier { property("min-height", "392px") },
        ) { Overlays(state, notify) },
        GallerySection(
            title = t("ds.table", "Table"),
            description = t(
                "ds.semantic_review_data_with_hover_and",
                "Semantic review data with hover and selected-row treatment.",
            ),
            icon = { LListChecksIcon() },
            modifier = wideModifier(),
        ) { TableSpecimen(state, notify) },
        GallerySection(
            title = t("ds.progress", "Progress"),
            description = t("ds.exact_approved_translated_and_empty_buckets", "Exact approved, translated, and empty buckets."),
            icon = { LRefreshIcon() },
            modifier = wideModifier(),
        ) { ProgressSpecimen(state, notify) },
        GallerySection(
            title = t("ds.states", "States"),
            description = t(
                "ds.what_a_surface_draws_before_instead",
                "What a surface draws before, instead of, and after its content.",
            ),
            icon = { LClockIcon() },
        ) { States(notify) },
        GallerySection(
            title = t("ds.empty_state", "Empty state"),
            description = t("ds.a_useful_next_step_when_there", "A useful next step when there is nothing to review."),
            icon = { LSearchXIcon() },
        ) { EmptyState(notify) },
        GallerySection(
            title = t("ds.identity", "Identity"),
            description = t(
                "ds.the_marks_a_project_a_section",
                "The marks a project, a section and an empty screen are known by.",
            ),
            icon = { LTagsIcon() },
            modifier = wideModifier(),
        ) { Identity() },
        GallerySection(
            title = t("ds.money_primitives", "Money primitives"),
            description = t(
                "ds.the_rows_and_fields_the_billing",
                "The rows and fields the billing, usage and receipt surfaces are made of.",
            ),
            icon = { LCoinsIcon() },
        ) { MoneyPrimitives(notify) },
    )
    sections.forEachIndexed { index, section ->
        Section(sectionNumber(index), section, section.content)
    }
}

/**
 * `0` -> `"01"`. Two digits, because the sheet passed ten sections and "9" beside "10" is ragged.
 *
 * One-based, because the masthead badge counts the sheet as `SYSTEM / 01` and the first section
 * under it used to be `00`: read together they said the page had a section before its first one.
 * Fifteen sections still fit in two digits.
 */
private fun sectionNumber(index: Int): String = (index + 1).toString().padStart(2, '0')

// ---------------------------------------------------------------------------------------------
// Icons
// ---------------------------------------------------------------------------------------------

/**
 * The whole glyph set, twice.
 *
 * Once on paper and once on ink, both drawn at fixed palettes rather than at the reader's, because
 * the question the sheet answers — does this glyph read on both grounds? — cannot be asked one
 * ground at a time. A sheet that followed `ColorMode.current` would show the same answer twice and
 * the pair of them would always agree.
 */
@Composable
private fun IconSheet() {
    IconGround(ColorMode.LIGHT, t("ds.on_paper", "On paper"))
    IconGround(ColorMode.DARK, t("ds.on_ink", "On ink"))
}

@Composable
private fun IconGround(mode: ColorMode, caption: String) {
    val palette = mode.toSitePalette()
    Column(Modifier.fillMaxWidth().gap(Space.MD)) {
        Label(caption)
        Div(
            DsGroundStyle.toModifier()
                .backgroundColor(palette.surfaceBase)
                .color(palette.textPrimary)
                .border(1.px, LineStyle.Solid, palette.border)
                .toAttrs { attr("data-icon-ground", mode.name.lowercase()) },
        ) {
            Div(DsIconSheetStyle.toModifier().toAttrs()) {
                ALL_ICONS.forEach { (name, render) ->
                    Div(DsIconCellStyle.toModifier().toAttrs { attr("data-icon-cell", name) }) {
                        Row(
                            Modifier.gap(Space.SM).flexWrap(FlexWrap.Wrap),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            ICON_RUNGS.forEach { rung -> render(Modifier.iconSize(rung)) }
                        }
                        Span(
                            Modifier.monoFont().color(palette.textMuted).fontSize(TypeScale.Micro)
                                .lineHeight(TypeScale.BodyLineHeight).toAttrs(),
                        ) { Text(name) }
                    }
                }
            }
        }
    }
}

/** Every rung of [IconSize], in order, so a glyph that only works at one of them shows it. */
private val ICON_RUNGS = listOf(
    IconSize.XS,
    IconSize.SM,
    IconSize.MD,
    IconSize.LG,
    IconSize.XL,
    IconSize.XXL,
    IconSize.Display,
)

// ---------------------------------------------------------------------------------------------
// Page chrome
// ---------------------------------------------------------------------------------------------

@Composable
private fun PageChrome(notify: Notify) {
    val pretranslateItems = pretranslateMenu()
    Specimen(t("ds.pageheader_mark_eyebrow_status_meta_actions", "PageHeader — mark, eyebrow, status, meta, actions")) {
        PageHeader(
            title = "Atlas Mobile", // i18n-ignore
            subtitle = t("ds.checkout_and_account_copy_for_the", "Checkout and account copy for the 2.8 release."),
            mark = { LProjectMark("Atlas Mobile", ProjectIconKey.SMARTPHONE, ProjectAccentKey.COBALT) }, // i18n-ignore
            eyebrow = {
                LBreadcrumbs(
                    listOf(
                        LBreadcrumbItem(t("ds.projects", "Projects"), "/ds"),
                        LBreadcrumbItem("Atlas Mobile"), // i18n-ignore
                    ),
                    label = t("ds.project_path", "Project path"),
                )
            },
            status = { LBadge(t("ds.in_review", "In review"), variant = LBadgeVariant.WARNING) },
            meta = {
                HeroFact(tf("ds.count_locales", "{count} locales", "count" to formatCount(8)))
                HeroFact(tf("ds.count_untranslated", "{count} untranslated", "count" to formatCount(412)))
                HeroFact(t("ds.updated_4_minutes_ago", "Updated 4 minutes ago"))
            },
            actions = {
                LSplitButton(
                    label = tf(
                        "ds.pre_translate_count_untranslated",
                        "Pre-translate {count} untranslated",
                        "count" to formatCount(412),
                    ),
                    onClick = { notify("Pre-translation started", LToastVariant.INFO) }, // i18n-ignore
                    items = pretranslateItems,
                    onSelect = { index ->
                        val entry = pretranslateItems[index]
                        if (entry is LMenuItem) notify("${entry.label} selected", LToastVariant.NEUTRAL)
                    },
                    leadingIcon = { LWandSparklesIcon() },
                )
            },
        )
    }
    Specimen(t("ds.lsectiontitle_and_lsectionheading_with_glyphs", "LSectionTitle and LSectionHeading, with glyphs")) {
        Column(Modifier.fillMaxWidth().gap(Space.LG)) {
            LSectionTitle(t("ds.who_holds_a_seat", "Who holds a seat"), icon = { LUsersIcon() })
            LSectionHeading(
                title = t("ds.release_readiness", "Release readiness"),
                description = t("ds.what_is_left_before_french_can", "What is left before French can ship."),
                icon = { LListChecksIcon() },
                actions = {
                    LButton(
                        t("ds.open_qa", "Open QA"),
                        { notify("QA opened", LToastVariant.INFO) }, // i18n-ignore
                        size = LButtonSize.SM,
                        variant = LButtonVariant.SECONDARY,
                        trailingIcon = { LArrowRightIcon() },
                    )
                },
            )
        }
    }
}

/**
 * The split button's menu, built the same way at both call sites that read it.
 *
 * A function rather than a `val`: every label goes through the catalogue, and a top-level value
 * would be evaluated at class-init — before any catalogue is fetched — and freeze in English for
 * the life of the page.
 */
@Composable
private fun pretranslateMenu(): List<LMenuEntry> = listOf(
    LMenuItem(t("ds.rewrite_every_string", "Rewrite every string"), icon = { LUndoIcon() }),
    LMenuItem(t("ds.gaps_in_french_only", "Gaps in French only"), icon = { LLanguagesIcon() }),
)

// ---------------------------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------------------------

@Composable
private fun Actions(state: GalleryState, notify: Notify) {
    LButtonVariant.entries.forEach { variant ->
        Specimen(label(variant.name)) {
            WrapRow {
                LButtonSize.entries.forEach { size ->
                    // Twelve buttons, three visible names. "Sm", "Md" and "Lg" each name four
                    // different controls with four different actions, and the specimen heading
                    // that tells them apart is a `Span` a screen reader has no reason to associate
                    // with them. `accessibleLabel` is the parameter that exists for exactly this.
                    LButton(
                        label(size.name),
                        { notify("${label(variant.name)} action recorded", LToastVariant.NEUTRAL) }, // i18n-ignore
                        variant = variant,
                        size = size,
                        accessibleLabel = "${label(variant.name)} ${label(size.name)}",
                    )
                }
            }
        }
    }
    LDivider(label = t("ds.states", "States"))
    WrapRow {
        LButton(
            t("ds.add_locale", "Add locale"),
            { notify("Locale picker opened", LToastVariant.INFO) }, // i18n-ignore
            leadingIcon = { LPlusIcon() },
        )
        LButton(t("ds.publishing", "Publishing"), {}, loading = true)
        LButton(t("ds.unavailable", "Unavailable"), {}, enabled = false)
        LButton(
            t("ds.open_the_receipt", "Open the receipt"),
            { notify("Receipt opened", LToastVariant.INFO) }, // i18n-ignore
            variant = LButtonVariant.SECONDARY,
            trailingIcon = { LArrowRightIcon() },
        )
    }
    Specimen(t("ds.icon_buttons", "Icon buttons")) {
        WrapRow {
            LButtonSize.entries.forEach { size ->
                LIconButton(
                    "Settings, ${label(size.name)}",
                    { notify("Project settings opened", LToastVariant.INFO) }, // i18n-ignore
                    size = size,
                ) { LSettingsIcon() }
            }
            LButtonVariant.entries.forEach { variant ->
                LIconButton("${label(variant.name)} icon button", {
                    notify("${label(variant.name)} icon action recorded", LToastVariant.NEUTRAL) // i18n-ignore
                }, variant = variant) { LGlobeIcon() }
            }
            LIconButton(t("ds.disabled_settings", "Disabled settings"), {}, enabled = false) { LSettingsIcon() }
        }
    }
    Specimen(t("ds.liconaction_the_name_is_the_tooltip", "LIconAction — the name is the tooltip")) {
        WrapRow {
            LIconAction(
                t("ds.refresh_the_queue", "Refresh the queue"),
                { notify("Queue refreshed", LToastVariant.SUCCESS) }, // i18n-ignore
                shortcut = "⌘R",
            ) { LRefreshIcon() }
            LIconAction(
                t("ds.undo_the_last_batch", "Undo the last batch"),
                { notify("Batch undone", LToastVariant.NEUTRAL) }, // i18n-ignore
                variant = LButtonVariant.SECONDARY,
            ) { LUndoIcon() }
            LIconAction(t("ds.more_actions", "More actions"), {}, enabled = false) { LSettingsIcon() }
        }
    }
    val approveItems = approveMenu()
    Specimen(t("ds.lsplitbutton_one_action_and_its_variants", "LSplitButton — one action and its variants")) {
        Column(Modifier.gap(Space.SM)) {
            LSplitButton(
                label = t("ds.approve_the_qa_clean_strings", "Approve the QA-clean strings"),
                onClick = { notify("96 strings approved", LToastVariant.SUCCESS) }, // i18n-ignore
                items = approveItems,
                onSelect = { index ->
                    val entry = approveItems[index]
                    if (entry is LMenuItem) state.lastMenuAction = entry.label
                },
                leadingIcon = { LCheckCheckIcon() },
            )
            LSplitButton(
                label = t("ds.publishing", "Publishing"),
                onClick = {},
                items = approveItems,
                onSelect = {},
                variant = LButtonVariant.SECONDARY,
                size = LButtonSize.SM,
                loading = true,
            )
            Readout(t("ds.last_action", "Last action"), state.lastMenuAction)
        }
    }
}

@Composable
private fun approveMenu(): List<LMenuEntry> = listOf(
    LMenuGroup(t("ds.scope", "Scope")),
    LMenuItem(t("ds.this_page_only", "This page only"), icon = { LListChecksIcon() }),
    LMenuItem(t("ds.every_pending_string", "Every pending string"), icon = { LCheckCheckIcon() }),
    LMenuSeparator,
    LMenuItem(t("ds.send_the_batch_back", "Send the batch back"), danger = true, icon = { LUndoIcon() }),
)

// ---------------------------------------------------------------------------------------------
// Forms
// ---------------------------------------------------------------------------------------------

@Composable
private fun Forms(state: GalleryState, notify: Notify) {
    var numericValue by remember { mutableStateOf<Double?>(24.0) }
    var mixedNumber by remember { mutableStateOf<Double?>(null) }
    var colorValue by remember { mutableStateOf<String?>("#425B76") }
    var mixedColor by remember { mutableStateOf<String?>(null) }
    val locales = listOf(
        LSelectOption("fr-FR", t("ds.french_france", "French — France")),
        LSelectOption("de-DE", t("ds.german_germany", "German — Germany")),
        LSelectOption("ja-JP", t("ds.japanese_japan", "Japanese — Japan")),
        LSelectOption("ar", t("ds.arabic", "Arabic"), disabled = true),
    )
    Div(DsSpecimenGridStyle.toModifier().toAttrs()) {
        LNumberField(numericValue, { numericValue = it }, label = t("ds.number_width", "Width"), unit = "px",
            min = 0.0, max = 1000.0, decimals = 1, onScrub = { numericValue = it })
        LNumberField(mixedNumber, { mixedNumber = it }, label = t("ds.number_rotation", "Rotation"), unit = "°")
        LNumberField(16.0, {}, label = t("ds.number_disabled", "Locked size"), unit = "px", enabled = false)
        LColorField(colorValue, { colorValue = it }, label = t("ds.color_fill", "Fill"),
            swatches = listOf("#425B76", "#E2B170", "#FFFFFF", "#000000"))
        LColorField(mixedColor, { mixedColor = it }, label = t("ds.color_mixed", "Text color"))
        LColorField("#425B76", {}, label = t("ds.color_disabled", "Locked color"), enabled = false)
        LTextField(state.newKey, { state.newKey = it }, label = t("ds.new_key", "New key"), placeholder = t("ds.account_actions_sign_out", "account.actions.sign_out"))
        LTextField(state.sourceKey, { state.sourceKey = it }, label = t("ds.string_key", "String key"), trailing = { LFileIcon() })
        LTextField(
            state.invalidKey,
            { state.invalidKey = it },
            label = t("ds.invalid_key", "Invalid key"),
            error = t("ds.use_dots_instead_of_spaces", "Use dots instead of spaces"),
        )
        LTextField("settings.billing.title", {}, label = t("ds.locked_source_key", "Locked source key"), enabled = false)
        LSelect(state.locale, locales, { state.locale = it }, label = t("ds.target_locale", "Target locale"))
        LSelect(
            state.invalidLocale,
            locales,
            { state.invalidLocale = it },
            label = t("ds.unavailable_locale", "Unavailable locale"),
            error = t("ds.enable_arabic_before_assigning_translators", "Enable Arabic before assigning translators"),
        )
        LSelect("de-DE", locales, {}, label = t("ds.archived_locale", "Archived locale"), enabled = false)
        LTextArea(state.translation, { state.translation = it }, label = t("ds.french_translation", "French translation"))
        LTextArea(
            state.longTranslation,
            { state.longTranslation = it },
            label = t("ds.character_limit", "Character limit"),
            error = t("ds.23_characters_over_the_64_character", "23 characters over the 64-character limit"),
        )
        LTextArea("Order confirmed", {}, label = t("ds.approved_translation", "Approved translation"), enabled = false)
        // `Label` is a styled `Span`: it groups these three controls visually and groups them to
        // nothing else, so a screen reader met three unrelated checkboxes with no idea they were
        // one set. `role="group"` plus `aria-labelledby` gives the heading the job it looks like
        // it already has, and reuses the same words rather than writing a second name to drift.
        Column(
            Modifier
                .gap(Space.MD)
                .attr("role", "group")
                .attr("aria-labelledby", CHECKBOX_GROUP_LABEL_ID),
        ) {
            Label(t("ds.checkboxes", "Checkboxes"), Modifier.attr("id", CHECKBOX_GROUP_LABEL_ID))
            LCheckbox(state.includeDrafts, { state.includeDrafts = it }, t("ds.include_draft_strings", "Include draft strings"))
            LCheckbox(state.onlyAssigned, { state.onlyAssigned = it }, t("ds.only_assigned_keys", "Only assigned keys"))
            LCheckbox(true, {}, t("ds.required_glossary", "Required glossary"), enabled = false)
            LCheckbox(
                false,
                { state.includeDrafts = it; state.onlyAssigned = it },
                t("ds.some_of_this_page", "Some of this page"),
                indeterminate = true,
            )
        }
        Column(
            Modifier
                .gap(Space.MD)
                .attr("role", "group")
                .attr("aria-labelledby", SWITCH_GROUP_LABEL_ID),
        ) {
            Label(t("ds.switches", "Switches"), Modifier.attr("id", SWITCH_GROUP_LABEL_ID))
            LSwitch(state.autoApprove, { state.autoApprove = it }, t("ds.auto_approve_exact_matches", "Auto-approve exact matches"))
            LSwitch(state.memoryEnabled, { state.memoryEnabled = it }, t("ds.translation_memory", "Translation memory"))
            LSwitch(false, {}, t("ds.machine_translation", "Machine translation"), enabled = false)
        }
    }
    Specimen(t("ds.ltogglechip_a_filter_that_carries_its", "LToggleChip — a filter that carries its own count")) {
        WrapRow {
            TAG_SAMPLES.forEach { (tag, count) ->
                LToggleChip(
                    text = tag,
                    selected = tag in state.selectedTags,
                    onSelectedChange = { on ->
                        state.selectedTags = if (on) state.selectedTags + tag else state.selectedTags - tag
                    },
                    count = count,
                    icon = { LTagIcon() },
                )
            }
            LToggleChip(t("ds.machine_output", "Machine output"), selected = false, onSelectedChange = {}, enabled = false)
        }
    }
    LFilterBar(
        fields = listOf(
            LFilterField(
                id = "gallery-filter-search",
                label = t("ds.search", "Search"),
                activeValue = state.query.takeIf { it.isNotBlank() },
                onClear = { state.query = "" },
            ) { modifier ->
                LSearchField(state.query, { state.query = it }, modifier = modifier, label = t("ds.search_strings", "Search strings"))
            },
            LFilterField(
                id = "gallery-filter-locale",
                label = t("ds.locale", "Locale"),
                activeValue = state.locale.takeIf { it != "fr-FR" },
                onClear = { state.locale = "fr-FR" },
            ) { modifier ->
                LSelect(state.locale, locales, { state.locale = it }, modifier = modifier, label = t("ds.locale", "Locale"))
            },
        ),
        onClearAll = { state.query = ""; state.locale = "fr-FR" },
        resultSummary = tPlural("ds.result_summary_matches", 18, "{count} match", "{count} matches"),
        actions = {
            LButton(
                t("ds.save_this_view", "Save this view"),
                { notify("View saved", LToastVariant.SUCCESS) }, // i18n-ignore
                size = LButtonSize.SM,
                variant = LButtonVariant.GHOST,
                leadingIcon = { LPlusIcon() },
            )
        },
    )
    LButton(
        t("ds.validate_sample", "Validate sample"),
        { notify("Sample fields passed validation", LToastVariant.SUCCESS) }, // i18n-ignore
        variant = LButtonVariant.SECONDARY,
        leadingIcon = { LGlobeIcon() },
    )
}

/** Fixture tags: a tag is data a project chose, never a word this product translates. */
private val TAG_SAMPLES = listOf("checkout" to 412, "account" to 96, "errors" to 18)

// ---------------------------------------------------------------------------------------------
// Signals
// ---------------------------------------------------------------------------------------------

@Composable
private fun Signals(state: GalleryState, notify: Notify) {
    WrapRow { LBadgeVariant.entries.forEach { LBadge(label(it.name), variant = it) } }
    Specimen(t("ds.badges_that_carry_state", "Badges that carry state")) {
        WrapRow {
            LBadge(t("ds.running", "Running"), variant = LBadgeVariant.ACCENT, leading = { LSpinner(size = LSpinnerSize.SM) })
            LBadge(t("ds.live", "Live"), variant = LBadgeVariant.SUCCESS, dot = true)
            LBadge(t("ds.blocked", "Blocked"), variant = LBadgeVariant.DANGER, dot = true)
        }
    }
    val alerts = listOf(
        AlertSample(LAlertVariant.INFO, "Import scanning", "Reading 248 keys from app_en.arb."), // i18n-ignore
        AlertSample(LAlertVariant.SUCCESS, "Locale published", "French is live in production."), // i18n-ignore
        AlertSample(LAlertVariant.WARNING, "Glossary drift", "12 translations use an outdated term."), // i18n-ignore
        AlertSample(LAlertVariant.DANGER, "Upload rejected", "Two ICU message patterns are malformed."), // i18n-ignore
    )
    Column(Modifier.gap(Space.MD)) {
        alerts.forEach { sample ->
            LAlert(sample.title, sample.description, variant = sample.variant, action = if (sample.variant == LAlertVariant.WARNING) {
                {
                    LButton(
                        t("ds.review", "Review"),
                        { notify("Glossary review opened", LToastVariant.INFO) }, // i18n-ignore
                        size = LButtonSize.SM,
                        variant = LButtonVariant.GHOST,
                    )
                }
            } else null)
        }
    }
    Specimen(t("ds.lalert_dense_and_dismissible", "LAlert — dense, and dismissible")) {
        if (state.denseAlertVisible) {
            LAlert(
                t("ds.two_providers_need_a_key", "Two providers need a key"),
                t("ds.machine_translation_is_off_until_one", "Machine translation is off until one is connected."),
                variant = LAlertVariant.WARNING,
                dense = true,
                onDismiss = { state.denseAlertVisible = false },
                action = {
                    LButton(
                        t("ds.connect", "Connect"),
                        { notify("Provider settings opened", LToastVariant.INFO) }, // i18n-ignore
                        size = LButtonSize.SM,
                        variant = LButtonVariant.GHOST,
                    )
                },
            )
        } else {
            LButton(
                t("ds.restore_the_banner", "Restore the banner"),
                { state.denseAlertVisible = true },
                size = LButtonSize.SM,
                variant = LButtonVariant.GHOST,
            )
        }
    }
}

// ---------------------------------------------------------------------------------------------
// Loading and notices
// ---------------------------------------------------------------------------------------------

@Composable
private fun LoadingAndNotices(state: GalleryState, toasts: ToastState, notify: Notify) {
    Specimen(t("ds.skeleton_shapes", "Skeleton shapes")) {
        Column(Modifier.gap(Space.SM)) {
            LSkeleton(shape = LSkeletonShape.TEXT, height = 14.px)
            LSkeleton(shape = LSkeletonShape.RECTANGLE, height = 72.px)
            LSkeleton(shape = LSkeletonShape.CIRCLE, width = 44.px, height = 44.px)
        }
    }
    Specimen(t("ds.spinner_sizes", "Spinner sizes")) {
        WrapRow {
            LSpinnerSize.entries.forEach { size ->
                Column(Modifier.gap(Space.XS), horizontalAlignment = Alignment.CenterHorizontally) {
                    LSpinner(size = size)
                    Label(label(size.name))
                }
            }
        }
    }
    Specimen(t("ds.toast_variants", "Toast variants")) {
        Column(Modifier.gap(Space.SM)) {
            LToastVariant.entries.filter { it in state.visibleToasts }.forEach { variant ->
                LToast(toastCopy(variant), { state.visibleToasts -= variant }, variant = variant)
            }
            if (state.visibleToasts.size < LToastVariant.entries.size) {
                LButton(t("ds.restore_notices", "Restore notices"), { state.visibleToasts = LToastVariant.entries.toSet() },
                    size = LButtonSize.SM, variant = LButtonVariant.GHOST)
            }
        }
    }
    Specimen(t("ds.a_toast_with_the_one_thing", "A toast with the one thing to do about it")) {
        LToast(
            "Approved 96 strings", // i18n-ignore
            { },
            variant = LToastVariant.SUCCESS,
            actionLabel = t("ds.undo", "Undo"),
            onAction = { notify("96 approvals reverted", LToastVariant.NEUTRAL) }, // i18n-ignore
        )
    }
    WrapRow {
        LButton(
            t("ds.show_success_toast", "Show success toast"),
            { notify("German catalog published", LToastVariant.SUCCESS) }, // i18n-ignore
        )
        LButton(
            t("ds.show_warning_toast", "Show warning toast"),
            { notify("18 strings still need review", LToastVariant.WARNING) }, // i18n-ignore
            variant = LButtonVariant.SECONDARY,
        )
        LButton(
            t("ds.show_a_toast_with_an_action", "Show a toast with an action"),
            {
                toasts.showWithAction(
                    "Pre-translation finished", // i18n-ignore
                    actionLabel = tr("ds.open_the_receipt", "Open the receipt"),
                    onAction = { notify("Receipt opened", LToastVariant.INFO) }, // i18n-ignore
                    variant = LToastVariant.SUCCESS,
                )
            },
            variant = LButtonVariant.GHOST,
        )
    }
}

// ---------------------------------------------------------------------------------------------
// Content
// ---------------------------------------------------------------------------------------------

@Composable
private fun ContentPrimitives(state: GalleryState, notify: Notify) {
    Specimen(t("ds.avatars", "Avatars")) {
        WrapRow {
            LAvatarSize.entries.forEach { LAvatar("Mina Patel", size = it) } // i18n-ignore
            LAvatar("Lingvo Bot") // i18n-ignore
        }
    }
    Specimen(t("ds.removable_chip", "Removable chip")) {
        WrapRow {
            if (state.chipVisible) LChip("fr-FR", onRemove = { state.chipVisible = false })
            else LButton(t("ds.restore_locale", "Restore locale"), { state.chipVisible = true }, size = LButtonSize.SM,
                variant = LButtonVariant.GHOST)
            LChip("Mobile checkout") // i18n-ignore
        }
    }
    LCard(content = {
        Column(Modifier.gap(Space.MD)) {
            Row(fillWrapModifier(), verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.gap(Space.XS)) {
                    LSectionTitle(
                        "Atlas Mobile", // i18n-ignore
                        modifier = Modifier.fontSize(TypeScale.HeadingSmall),
                        // A glyph, not the project mark: the title's icon box is `1em` square so it
                        // follows the line it stands beside, and a 40px mark would burst it.
                        icon = { LSmartphoneIcon() },
                    )
                    Label("8 locales · updated 4 min ago") // i18n-ignore
                }
                LBadge(t("ds.in_review", "In review"), variant = LBadgeVariant.WARNING)
            }
            BodyCopy("Checkout and account copy prepared for the 2.8 release.") // i18n-ignore
            LButton(
                t("ds.open_project", "Open project"),
                { notify("Atlas Mobile opened", LToastVariant.INFO) }, // i18n-ignore
                size = LButtonSize.SM,
                variant = LButtonVariant.SECONDARY,
            )
        }
    })
    Specimen(t("ds.ldisclosure_a_group_that_says_how", "LDisclosure — a group that says how big it is")) {
        Column(Modifier.fillMaxWidth().gap(Space.SM)) {
            LDisclosure(
                title = t("ds.placeholder_mismatches", "Placeholder mismatches"),
                expanded = state.disclosureExpanded,
                onExpandedChange = { state.disclosureExpanded = it },
                badge = { LBadge(formatCount(12), variant = LBadgeVariant.WARNING) },
                icon = { LCircleAlertIcon() },
            ) {
                BodyCopy("Twelve French strings drop {count} from the English source.") // i18n-ignore
            }
            LDisclosure(
                title = t("ds.terms_that_drifted", "Terms that drifted"),
                expanded = state.secondDisclosureExpanded,
                onExpandedChange = { state.secondDisclosureExpanded = it },
                badge = { LBadge(formatCount(3), variant = LBadgeVariant.NEUTRAL) },
                icon = { LTagsIcon() },
            ) {
                BodyCopy("Three strings still say “panier” where the glossary says “commande”.") // i18n-ignore
            }
        }
    }
}

// ---------------------------------------------------------------------------------------------
// Navigation and filters
// ---------------------------------------------------------------------------------------------

@Composable
private fun Navigation(state: GalleryState, notify: Notify) {
    val tabs = listOf(
        LTab("translation", t("ds.translation", "Translation")) { TabCopy("Confirmer la commande", "Approved by Mina Patel") }, // i18n-ignore
        LTab("comments", t("ds.comments", "Comments")) { TabCopy("Keep “checkout” concise on mobile.", "2 reviewer notes") }, // i18n-ignore
        LTab("history", t("ds.history", "History")) { TabCopy("Source changed from “Confirm order”.", "August 9 at 16:42") }, // i18n-ignore
        LTab("qa", t("ds.qa", "QA"), enabled = false) { TabCopy("No blocking issues", "Checks run on publish") }, // i18n-ignore
    )
    LTabs(tabs, state.selectedTab, { state.selectedTab = it }, label = t("ds.string_detail", "String detail"))
    LSegmented(
        listOf(
            LSegmentedOption("en", t("ds.english", "English")),
            LSegmentedOption("fr", t("ds.french", "French")),
            LSegmentedOption("de", t("ds.german", "German")),
            LSegmentedOption("ja", t("ds.japanese", "Japanese"), enabled = false),
        ),
        state.selectedLocale,
        { state.selectedLocale = it },
        t("ds.preview_locale", "Preview locale"),
    )
    LSearchField(state.query, { state.query = it }, onCommit = {
        notify(
            if (state.query.isBlank()) "Enter a key or translation to search" else "Searching for “${state.query}”", // i18n-ignore
            LToastVariant.INFO,
        )
    })
    LSearchField("account", {}, label = t("ds.disabled_search", "Disabled search"), enabled = false, shortcutHint = null)
    LDivider(label = t("ds.shortcuts", "Shortcuts"))
    WrapRow {
        LKbd("Esc")
        Label(t("ds.close_panel", "Close panel"))
    }
    Specimen(t("ds.lchord_a_written_chord_read_as", "LChord — a written chord, read as its keys")) {
        Column(Modifier.gap(Space.SM)) {
            Row(Modifier.gap(Space.SM).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                LChord(commandChordKeys("K"))
                Label(t("ds.open_the_command_menu", "Open the command menu"))
            }
            Row(Modifier.gap(Space.SM).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                LChord(chordKeys("⌘⇧↓"))
                Label(t("ds.jump_to_the_next_qa_issue", "Jump to the next QA issue"))
            }
        }
    }
    LBreadcrumbs(
        listOf(
            LBreadcrumbItem(t("ds.projects", "Projects"), "/ds"),
            LBreadcrumbItem("Atlas Mobile", "/ds"), // i18n-ignore
            LBreadcrumbItem(t("ds.french", "French")),
        ),
        label = t("ds.project_path", "Project path"),
    )
}

// ---------------------------------------------------------------------------------------------
// Table
// ---------------------------------------------------------------------------------------------

@Composable
private fun TableSpecimen(state: GalleryState, notify: Notify) {
    val rows = TABLE_ROWS
    val selection = when (state.selectedRows.size) {
        0 -> LTableSelection.NONE
        rows.size -> LTableSelection.ALL
        else -> LTableSelection.SOME
    }
    LTable(caption = t("ds.french_release_review_queue", "French release review queue")) {
        LTableHead {
            LTableRow {
                LTableSelectAllHeaderCell(
                    state = selection,
                    onChange = { everything ->
                        state.selectedRows = if (everything) rows.map(TranslationRow::key).toSet() else emptySet()
                    },
                    label = t("ds.select_every_row_on_this_page", "Select every row on this page"),
                    modifier = Modifier.attr("id", SELECT_ALL_HEADER_ID),
                )
                LTableHeaderCell { Text(t("ds.string_key", "String key")) }
                LTableHeaderCell { Text(t("ds.french_translation", "French translation")) }
                LTableHeaderCell { Text(t("ds.status", "Status")) }
                LTableHeaderCell(align = LTableAlign.END) { Text(t("ds.strings", "Strings")) }
            }
        }
        LTableBody {
            rows.forEach { row ->
                LTableRow(
                    selected = row.key in state.selectedRows,
                    selectable = true,
                    onSelectedChange = { on ->
                        state.selectedRows =
                            if (on) state.selectedRows + row.key else state.selectedRows - row.key
                    },
                    selectionLabel = tf("ds.select_key", "Select {key}", "key" to row.key),
                ) {
                    LTableHeaderCell(scope = LTableHeaderScope.ROW) {
                        Span(Modifier.monoFont().toAttrs()) { Text(row.key) }
                    }
                    LTableCell { Text(row.translation) }
                    LTableCell { LBadge(row.status, variant = row.variant) }
                    LTableCell(align = LTableAlign.END) { Text(formatCount(row.strings)) }
                }
            }
        }
    }
    LBulkActionBar(
        selectedCount = state.selectedRows.size,
        onClear = { state.selectedRows = emptySet() },
        label = tPlural(
            "ds.bulk_selected_strings",
            state.selectedRows.size,
            "{count} string selected",
            "{count} strings selected",
        ),
        note = tf(
            "ds.selection_covers_the_count_loaded_rows",
            "Selection covers the {count} loaded rows.",
            "count" to formatCount(rows.size),
        ),
        returnFocusToId = SELECT_ALL_HEADER_ID,
    ) {
        LButton(
            t("ds.approve", "Approve"),
            { notify("Selection approved", LToastVariant.SUCCESS) }, // i18n-ignore
            size = LButtonSize.SM,
            leadingIcon = { LCheckCheckIcon() },
        )
        LButton(
            t("ds.export", "Export"),
            { notify("Export started", LToastVariant.INFO) }, // i18n-ignore
            size = LButtonSize.SM,
            variant = LButtonVariant.SECONDARY,
            leadingIcon = { LDownloadIcon() },
        )
    }
    LPagination(
        state = LPageState(shown = 4, pageSize = 100, hasOlder = true, hasNewer = false, pageNumber = 1),
        onOlder = { notify("Older page requested.", LToastVariant.INFO) }, // i18n-ignore
        onNewer = {},
        unit = t("ds.strings_unit", "strings"),
    )
}

private const val SELECT_ALL_HEADER_ID = "ds-table-select-all"

private val TABLE_ROWS = listOf(
    TranslationRow("checkout.confirm", "Confirmer la commande", "Approved", LBadgeVariant.SUCCESS, 1284),
    TranslationRow("checkout.payment", "Paiement sécurisé", "Selected", LBadgeVariant.ACCENT, 860),
    TranslationRow("account.delete", "Supprimer le compte", "Needs review", LBadgeVariant.WARNING, 120),
    TranslationRow("orders.empty", "Aucune commande", "Draft", LBadgeVariant.NEUTRAL, 42),
)

// ---------------------------------------------------------------------------------------------
// Progress
// ---------------------------------------------------------------------------------------------

@Composable
private fun ProgressSpecimen(state: GalleryState, notify: Notify) {
    val samples = listOf(
        "Atlas Mobile" to LProgressCounts(1_284, 197, 968), // i18n-ignore
        "Merchant Portal" to LProgressCounts(860, 102, 688), // i18n-ignore
        "Release notes" to LProgressCounts(120, 19, 73), // i18n-ignore
    )
    samples.forEach { (name, progress) ->
        Specimen(name) {
            LProgressBar(
                progress,
                label = tf("ds.progress_bar_label", "{name} translation progress", "name" to name),
                showCounts = true,
            )
        }
    }
    Specimen(t("ds.lprogressbar_compact_for_a_header", "LProgressBar — compact, for a header")) {
        LProgressBar(
            samples.first().second,
            label = t("ds.release_progress", "Release progress"),
            compact = true,
        )
    }
    Specimen(t("ds.svg_ring_sizes", "SVG ring sizes")) {
        WrapRow {
            LProgressRingSize.entries.forEach { size ->
                Column(Modifier.gap(Space.XS), horizontalAlignment = Alignment.CenterHorizontally) {
                    LProgressRing(
                        samples.first().second,
                        label = tf("ds.ring_progress", "Atlas Mobile {size} progress", "size" to label(size.name)),
                        size = size,
                    )
                    Label(label(size.name))
                }
            }
        }
    }
    Specimen(t("ds.ltaskprogress_a_run_in_three_states", "LTaskProgress — a run, in three states")) {
        Column(Modifier.fillMaxWidth().gap(Space.LG)) {
            LTaskProgress(
                done = 208,
                total = 210,
                failed = 2,
                label = t("ds.pre_translation_progress", "Pre-translation progress"),
                detail = t("ds.french_deepl", "French · DeepL"),
            )
            LTaskProgress(done = 34, total = 210, label = t("ds.pre_translation_progress", "Pre-translation progress"))
            LTaskProgress(
                done = 0,
                total = 0,
                indeterminate = true,
                label = t("ds.pre_translation_progress", "Pre-translation progress"),
            )
        }
    }
    Specimen(t("ds.lstattile_the_counts_a_decision_is", "LStatTile — the counts a decision is made from")) {
        Div(DsSpecimenGridStyle.toModifier().toAttrs()) {
            LStatTile(
                t("ds.untranslated", "Untranslated"),
                formatCount(412),
                icon = { LLanguagesIcon() },
                delta = LStatDelta(t("ds.38_fewer_than_last_week", "38 fewer than last week"), LStatDirection.DOWN),
                tone = LBadgeVariant.WARNING,
                emphasis = true,
            )
            LStatTile(t("ds.awaiting_review", "Awaiting review"), formatCount(96), icon = { LListChecksIcon() }, href = "/ds")
            LStatTile(
                t("ds.qa_errors", "QA errors"),
                formatCount(0),
                icon = { LCircleAlertIcon() },
                onClick = { notify("QA opened", LToastVariant.INFO) }, // i18n-ignore
            )
            LStatTile(t("ds.approved", "Approved"), formatCount(1_284), compact = true)
        }
    }
    Specimen(t("ds.reorder_list", "LReorderList — drag or use the keyboard")) {
        var shots by remember { mutableStateOf(listOf("Home", "Main task", "Settings")) } // i18n-ignore
        LReorderList(shots, key = { it }, onMove = { from, to ->
            shots = shots.toMutableList().apply { add(to, removeAt(from)) }
        }, label = t("ds.shot_order", "Shot order"), itemLabel = { it }) { shot, grip ->
            Row(Modifier.gap(Space.MD)) {
                LIconAction(label = tf("ds.reorder_shot", "Reorder {shot}", "shot" to shot),
                    onClick = {}, modifier = grip) { LGripVerticalIcon() }
                Text(shot)
            }
        }
    }
    Specimen(t("ds.lsteps_where_a_flow_has_got", "LSteps — where a flow has got to")) {
        Column(Modifier.fillMaxWidth().gap(Space.LG)) {
            LSteps(
                steps = importSteps(),
                current = state.stepIndex,
                completed = (0 until state.stepIndex).toSet(),
                label = t("ds.import_a_catalogue", "Import a catalogue"),
            )
            WrapRow {
                LButton(
                    t("ds.previous_step", "Previous step"),
                    { state.stepIndex = (state.stepIndex - 1).coerceAtLeast(0) },
                    size = LButtonSize.SM,
                    variant = LButtonVariant.GHOST,
                )
                LButton(
                    t("ds.next_step", "Next step"),
                    { state.stepIndex = (state.stepIndex + 1).coerceAtMost(IMPORT_STEP_COUNT - 1) },
                    size = LButtonSize.SM,
                    variant = LButtonVariant.SECONDARY,
                )
            }
        }
    }
}

@Composable
private fun importSteps(): List<LStep> = listOf(
    LStep(t("ds.choose_a_file", "Choose a file"), t("ds.point_at_the_catalogue_in_your", "Point at the catalogue in your repository.")),
    LStep(t("ds.map_the_locales", "Map the locales"), t("ds.say_which_file_is_which_language", "Say which file is which language.")),
    LStep(t("ds.review_the_import", "Review the import"), t("ds.nothing_is_written_until_you_agree", "Nothing is written until you agree.")),
)

private const val IMPORT_STEP_COUNT = 3

// ---------------------------------------------------------------------------------------------
// Overlays
// ---------------------------------------------------------------------------------------------

@Composable
private fun Overlays(state: GalleryState, notify: Notify) {
    val items = listOf(
        LMenuItem(t("ds.project_settings", "Project settings"), icon = { LSettingsIcon() }),
        LMenuItem(t("ds.export_xliff", "Export XLIFF"), icon = { LFileIcon() }),
        LMenuItem(t("ds.duplicate_project", "Duplicate project"), disabled = true),
        LMenuItem(t("ds.archive_project", "Archive project"), danger = true),
    )
    Specimen(t("ds.menu", "Menu")) {
        Column(Modifier.gap(Space.SM)) {
            LMenu(state.menuExpanded, items, { state.menuExpanded = it }, { index ->
                state.lastMenuAction = items[index].label
                notify("${items[index].label} selected", LToastVariant.INFO) // i18n-ignore
            }) { toggle, triggerModifier ->
                LButton(t("ds.project_actions", "Project actions"), toggle, modifier = triggerModifier, variant = LButtonVariant.SECONDARY)
            }
            Readout(t("ds.last_action", "Last action"), state.lastMenuAction)
        }
    }
    Specimen(t("ds.menu_entries_groups_checks_and_chords", "Menu entries — groups, checks and chords")) {
        Column(Modifier.gap(Space.SM)) {
            val entries = runMenu(state.showMachineOutput)
            LMenu(
                expanded = state.entryMenuExpanded,
                entries = entries,
                onExpandedChange = { state.entryMenuExpanded = it },
                onSelect = { index ->
                    val entry = entries[index]
                    if (entry is LMenuItem) {
                        if (entry.checked != null) state.showMachineOutput = !state.showMachineOutput
                        state.lastMenuAction = entry.label
                    }
                },
                placement = LMenuPlacement.BOTTOM_START,
            ) { toggle, triggerModifier ->
                LButton(t("ds.run_menu", "Run menu"), toggle, modifier = triggerModifier, variant = LButtonVariant.GHOST)
            }
        }
    }
    Specimen(t("ds.tooltip", "Tooltip")) {
        WrapRow {
            LTooltip(t("ds.configure_locale_rules", "Configure locale rules")) { triggerModifier ->
                LIconButton(
                    t("ds.locale_settings", "Locale settings"),
                    { notify("Locale settings opened", LToastVariant.INFO) }, // i18n-ignore
                    modifier = triggerModifier,
                ) {
                    LSettingsIcon()
                }
            }
            Label(t("ds.hover_or_focus_the_icon", "Hover or focus the icon"))
        }
    }
    Specimen(t("ds.modal_sizes", "Modal sizes")) {
        WrapRow {
            LModalSize.entries.forEach { size ->
                LButton(label(size.name), { state.modalSize = size }, size = LButtonSize.SM,
                    variant = LButtonVariant.SECONDARY)
            }
        }
    }
    Specimen(t("ds.code_block", "Code block")) {
        LCodeBlock(
            text = "{\n  \"action\": \"translation.updated\",\n  \"count\": 1284\n}",
            label = t("ds.detail", "Detail"),
            language = LCodeLanguage.JSON,
        )
    }
    // Inside the section, where every other specimen lives. This closing brace used to sit
    // above it, so "Confirmation" rendered as a direct child of the page grid with no card
    // behind it — a label and a red button on the bare page ground, with ~570px of empty
    // colour under them where the grid row matched the taller Overlays card beside it.
    Specimen(t("ds.confirmation", "Confirmation")) {
        LButton(t("ds.delete_sample", "Delete sample"), { state.confirmationOpen = true }, variant = LButtonVariant.DANGER)
    }
    LModal(state.modalSize != null, t("ds.publish_french_locale", "Publish French locale"), { state.modalSize = null },
        size = state.modalSize ?: LModalSize.MD, actions = {
            LButton(t("ds.cancel", "Cancel"), { state.modalSize = null }, variant = LButtonVariant.GHOST)
            LButton(t("ds.publish_locale", "Publish locale"), {
                state.modalSize = null
                notify("French locale published", LToastVariant.SUCCESS) // i18n-ignore
            })
        }) {
        LAlert(t("ds.ready_for_production", "Ready for production"), t("ds.1_284_strings_are_approved_reviewers", "1,284 strings are approved. Reviewers will receive a release note."),
            variant = LAlertVariant.SUCCESS)
        LCheckbox(state.notifyTranslators, { state.notifyTranslators = it }, t("ds.notify_assigned_translators", "Notify assigned translators"))
    }
    LConfirmDialog(
        open = state.confirmationOpen,
        title = t("ds.delete_sample_workspace", "Delete sample workspace?"),
        confirmLabel = t("ds.delete_workspace", "Delete workspace"),
        onConfirm = {
            state.confirmationOpen = false
            notify("Sample workspace deleted", LToastVariant.SUCCESS) // i18n-ignore
        },
        onCancel = { state.confirmationOpen = false },
        consequenceTitle = t("ds.this_cannot_be_undone", "This cannot be undone"),
        consequence = t("ds.it_removes_12_projects_4_812", "It removes 12 projects, 4,812 keys and every translation."),
        typeToConfirm = "sample-workspace",
    )
}

@Composable
private fun runMenu(showMachineOutput: Boolean): List<LMenuEntry> = listOf(
    LMenuGroup(t("ds.run", "Run")),
    LMenuItem(
        t("ds.pre_translate_the_gaps", "Pre-translate the gaps"),
        icon = { LWandSparklesIcon() },
        shortcut = "⌘⇧P",
        description = t("ds.412_untranslated_strings_in_3_locales", "412 untranslated strings in 3 locales"),
    ),
    LMenuItem(t("ds.re_run_qa", "Re-run QA"), icon = { LListChecksIcon() }, shortcut = "⌘⇧Q"),
    LMenuSeparator,
    LMenuGroup(t("ds.view", "View")),
    LMenuItem(t("ds.show_machine_output", "Show machine output"), checked = showMachineOutput),
    LMenuItem(t("ds.stop_this_run", "Stop this run"), danger = true, icon = { LUndoIcon() }),
)

// ---------------------------------------------------------------------------------------------
// States
// ---------------------------------------------------------------------------------------------

@Composable
private fun States(notify: Notify) {
    Specimen(t("ds.loadingstate_one_sentence_not_one_per", "LoadingState — one sentence, not one per bar")) {
        LoadingState(rows = 2, label = t("ds.loading_the_review_queue", "Loading the review queue"))
    }
    Specimen(t("ds.errorstate", "ErrorState")) {
        ErrorState(
            message = t("ds.the_server_did_not_answer_in", "The server did not answer in time."),
            onRetry = { notify("Retried", LToastVariant.INFO) }, // i18n-ignore
        )
    }
    Specimen(t("ds.asyncfailurestate_refused_missing_and_broken", "AsyncFailureState — refused, missing, and broken")) {
        Column(Modifier.fillMaxWidth().gap(Space.LG)) {
            AsyncFailureState(
                failure = Async.Failure(
                    message = t("ds.owners_and_admins_can_read_usage", "Owners and admins can read usage."),
                    status = 403,
                ),
                subject = t("ds.usage", "usage"),
            )
            AsyncFailureState(
                failure = Async.Failure(
                    message = t("ds.that_project_was_deleted", "That project was deleted."),
                    status = 404,
                ),
            )
            AsyncFailureState(
                failure = Async.Failure(
                    message = t("ds.the_server_did_not_answer_in", "The server did not answer in time."),
                    status = 503,
                ),
                faultMessage = t(
                    "ds.ledger_read_unavailable",
                    "We can't read the ledger right now. Retry to check the recorded totals.",
                ),
                onRetry = { notify("Retried", LToastVariant.INFO) }, // i18n-ignore
            )
        }
    }
    Specimen(t("ds.lasynccontent_the_three_arms_of_one", "LAsyncContent — the three arms of one load")) {
        Column(Modifier.fillMaxWidth().gap(Space.LG)) {
            LAsyncContent<String>(
                state = Async.Loading,
                rows = 1,
                loadingLabel = t("ds.loading_the_review_queue", "Loading the review queue"),
            ) { value -> BodyCopy(value) }
            LAsyncContent(
                state = Async.Failure(
                    message = t("ds.owners_and_admins_can_read_usage", "Owners and admins can read usage."),
                    status = 403,
                ),
                subject = t("ds.usage", "usage"),
            ) { value: String -> BodyCopy(value) }
            LAsyncContent(
                state = Async.Success("1,284 approved strings, 96 waiting for review."), // i18n-ignore
            ) { value -> BodyCopy(value) }
        }
    }
}

// ---------------------------------------------------------------------------------------------
// Identity
// ---------------------------------------------------------------------------------------------

@Composable
private fun Identity() {
    Specimen(t("ds.lprojectmark_every_icon_against_every_accent", "LProjectMark — every icon against every accent")) {
        Div(DsIdentityGridStyle.toModifier().toAttrs()) {
            ProjectIconKey.entries.forEach { iconKey ->
                ProjectAccentKey.entries.forEach { accentKey ->
                    Column(
                        Modifier.gap(Space.XS),
                        horizontalAlignment = Alignment.CenterHorizontally,
                    ) {
                        LProjectMark("Atlas Mobile", iconKey, accentKey) // i18n-ignore
                        Label("${label(iconKey.name)} · ${label(accentKey.name)}")
                    }
                }
            }
        }
    }
    Specimen(t("ds.liconbadge_a_glyph_that_is_the", "LIconBadge — a glyph that is the subject")) {
        WrapRow {
            LIconBadge { LZapIcon(Modifier.iconSize(IconSize.XXL)) }
            LIconBadge { LShieldIcon(Modifier.iconSize(IconSize.XXL)) }
            LIconBadge { LCoinsIcon(Modifier.iconSize(IconSize.XXL)) }
            LIconBadge { LWandSparklesIcon(Modifier.iconSize(IconSize.XXL)) }
        }
    }
    Specimen(t("ds.lemptystateicon_all_fifteen", "LEmptyStateIcon — all fifteen")) {
        Div(DsGlyphGridStyle.toModifier().toAttrs()) {
            LEmptyStateIcon.entries.forEach { icon ->
                LEmptyState(
                    title = label(icon.name),
                    description = t(
                        "ds.the_glyph_this_entry_draws_and",
                        "The glyph this entry draws, and the screen it belongs on.",
                    ),
                    icon = icon,
                )
            }
        }
    }
}

// ---------------------------------------------------------------------------------------------
// Empty state
// ---------------------------------------------------------------------------------------------

@Composable
private fun EmptyState(notify: Notify) {
    LEmptyState(
        t("ds.no_untranslated_strings", "No untranslated strings"),
        t("ds.french_is_caught_up_with_the", "French is caught up with the current English source."),
        icon = LEmptyStateIcon.LANGUAGE,
        secondaryAction = {
            LButton(
                t("ds.read_the_import_guide", "Read the import guide"),
                { notify("Guide opened", LToastVariant.INFO) }, // i18n-ignore
                size = LButtonSize.SM,
                variant = LButtonVariant.GHOST,
            )
        },
    ) {
        LButton(
            t("ds.import_new_source", "Import new source"),
            { notify("Source importer opened", LToastVariant.INFO) }, // i18n-ignore
            leadingIcon = { LPlusIcon() },
        )
    }
}

// ---------------------------------------------------------------------------------------------
// Money primitives
// ---------------------------------------------------------------------------------------------

/**
 * The four components Polyglot phase C adds.
 *
 * They live together because they share an audience: every one of them appears on a surface where a
 * number becomes a charge, and each exists because a figure there has to be traceable to the one
 * before it.
 */
@Composable
private fun MoneyPrimitives(notify: Notify) {
    Specimen(t("ds.lkeyvaluerow_numeric_and_prose", "LKeyValueRow — numeric and prose")) {
        Column(Modifier.fillMaxWidth().maxWidth(34.cssRem)) {
            LKeyValueRow(
                label = t("ds.last_invoice", "Last invoice"),
                value = "$114.00 · 3 Aug 2026",
                link = LKeyValueLink(t("ds.all_invoices", "All invoices"), "/app/settings/billing/invoices"),
            )
            LKeyValueRow(label = t("ds.billable_seats", "Billable seats"), value = "6 owner and admin seats")
            // A sentence in a right-aligned slot gets a new start position on every line.
            LKeyValueRow(
                label = t("ds.seat_sync", "Seat sync"),
                value = "Matches your subscription. Last checked 4 minutes ago.",
                kind = LKeyValueKind.PROSE,
                hairline = false,
            )
        }
    }

    Specimen(t("ds.lstatrow_a_ledger_that_ships_its", "LStatRow — a ledger that ships its own table")) {
        Column(Modifier.fillMaxWidth().maxWidth(34.cssRem)) {
            LStatRow(
                caption = t("ds.credits_this_period", "Credits this period"),
                rows = listOf(
                    LStatRowItem("Included with Studio (6 seats)", "30,000"), // i18n-ignore
                    LStatRowItem("Granted", "0"), // i18n-ignore
                    LStatRowItem("Used since 1 August", "28,412"), // i18n-ignore
                    LStatRowItem("Left", "1,588", emphasis = true), // i18n-ignore
                ),
            )
        }
    }

    Specimen(t("ds.lcopyfield_elided_on_screen_whole_on", "LCopyField — elided on screen, whole on the clipboard")) {
        LCopyField(
            value = "9f3c1e7a-4b62-4a9d-8e51-0c2d7a6f41b8",
            // A noun: the component builds "Copy job ID" from it.
            label = t("ds.job_id", "job ID"),
            onCopied = { notify("Job ID copied.", LToastVariant.SUCCESS) }, // i18n-ignore
            onCopyFailed = { notify("Couldn't reach the clipboard.", LToastVariant.DANGER) }, // i18n-ignore
        )
    }

    Specimen(t("ds.ldaterange_the_caption_is_permanent_not", "LDateRange — the caption is permanent, not a tooltip")) {
        LDateRange(
            from = "2026-08-01",
            to = "2026-09-01",
            onChange = { from, to -> notify("Range $from to $to", LToastVariant.INFO) },
        )
    }

    // Two versions of one string, which is what a reviewer and a history panel both look at. The
    // deletion is struck through and muted rather than coloured — it is context for reading the
    // addition beside it, not a second thing competing for attention — and each part carries a
    // visually-hidden "added: " / "removed: " marker, because `<del>` and `<ins>` are
    // name-prohibited and an `aria-label` on them is discarded by every engine that implements the
    // rule. Without the markers the two versions interleave into one run-on sentence when read aloud.
    Specimen(t("ds.ldifftext_a_diff_that_survives_being", "LDiffText — a diff that survives being read aloud")) {
        // Each sample in its own Div, and that is not decoration. LDiffText renders no host
        // element — it emits bare text nodes and <del>/<ins> siblings into whatever parent calls
        // it, which is what lets it flow inline inside a sentence at both editor call sites. Put
        // straight into this Column, every one of those fragments became a flex item: the three
        // samples rendered as nine stacked lines, and the trailing text of one ran into the
        // leading text of the next ("your card.Save") because two adjacent text nodes collapse
        // into a single anonymous item. The Div gives each sample one flow context of its own.
        Column(Modifier.fillMaxWidth().gap(Space.MD)) {
            Div { LDiffText("Payment failed. Update your card.", "Payment declined. Please update your card.") }
            Div { LDiffText("Save changes", "Save") }
            // Every part REMOVED: a cleared translation, which used to read back as unchanged.
            Div { LDiffText("Delete this project", "") }
        }
    }
}

// ---------------------------------------------------------------------------------------------
// Scaffolding
// ---------------------------------------------------------------------------------------------

/** One card of the sheet: what it shows, the glyph that marks it, and how wide it sits. */
private class GallerySection(
    val title: String,
    val description: String,
    val icon: @Composable () -> Unit,
    val modifier: Modifier = Modifier,
    val content: @Composable () -> Unit,
)

@Composable
private fun Section(number: String, section: GallerySection, content: @Composable () -> Unit) {
    Column(DsSectionStyle.toModifier().then(section.modifier).gap(Space.XL)) {
        LSectionHeading(
            title = section.title,
            description = section.description,
            icon = section.icon,
            actions = { Label(number) },
        )
        content()
    }
}

@Composable
private fun BodyCopy(text: String) {
    P(Modifier.maxWidth(48.cssRem).color(ColorMode.current.toSitePalette().textSecondary)
        .fontSize(TypeScale.BodySmall).lineHeight(TypeScale.BodyLineHeight).margin(0.px).toAttrs()) { Text(text) }
}

/** One fact in a `PageHeader`'s meta row. The row itself supplies the colour and the size. */
@Composable
private fun HeroFact(text: String) {
    Span(Modifier.toAttrs()) { Text(text) }
}

@Composable
private fun Specimen(name: String, content: @Composable () -> Unit) {
    Column(Modifier.fillMaxWidth().gap(Space.SM)) {
        Label(name)
        content()
    }
}

/**
 * A value the specimen above just produced, named by a [Label] and set as body text.
 *
 * The menu readout used to be a bare `Label` — the same mono/Micro/uppercase/+0.08em vocabulary
 * every specimen *heading* uses, and every other one of those sits above the thing it names. Under
 * the split-button pair it read as the heading of a specimen that was not there: "NO ACTION
 * SELECTED", captioning nothing. State does not get set in the type reserved for headings, so the
 * name goes back on top where a heading belongs and the value drops to [TypeScale.Small].
 */
@Composable
private fun Readout(name: String, value: String) {
    Column(Modifier.gap(Space.XS)) {
        Label(name)
        Span(
            Modifier
                .color(ColorMode.current.toSitePalette().textSecondary)
                .fontSize(TypeScale.Small)
                .lineHeight(TypeScale.BodyLineHeight)
                .toAttrs(),
        ) { Text(value) }
    }
}

@Composable
private fun Label(text: String, modifier: Modifier = Modifier) {
    Span(Modifier.monoFont().color(ColorMode.current.toSitePalette().textMuted).fontSize(TypeScale.Micro)
        .fontWeight(500).lineHeight(TypeScale.BodyLineHeight).styleModifier {
            property("letter-spacing", "0.08em")
            property("text-transform", "uppercase")
        }.then(modifier).toAttrs()) { Text(text) }
}

/** Ties each control group to the line that names it. One gallery renders at a time. */
private const val CHECKBOX_GROUP_LABEL_ID = "ds-checkbox-group-label"
private const val SWITCH_GROUP_LABEL_ID = "ds-switch-group-label"

@Composable
private fun WrapRow(content: @Composable () -> Unit) {
    Row(Modifier.gap(Space.SM).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) { content() }
}

@Composable
private fun TabCopy(text: String, metadata: String) {
    Column(Modifier.gap(Space.XS).padding(top = Space.LG)) {
        Div(Modifier.fontSize(TypeScale.BodySmall).fontWeight(600).toAttrs()) { Text(text) }
        Label(metadata)
    }
}

private class GalleryState {
    var newKey by mutableStateOf("")
    var sourceKey by mutableStateOf("checkout.confirm")
    var invalidKey by mutableStateOf("checkout confirm")
    var translation by mutableStateOf("Confirmer la commande")
    var longTranslation by mutableStateOf("Bestätigen Sie Ihre Bestellung jetzt und fahren Sie sicher fort.")
    var locale by mutableStateOf("fr-FR")
    var invalidLocale by mutableStateOf("ar")
    var includeDrafts by mutableStateOf(true)
    var onlyAssigned by mutableStateOf(false)
    var autoApprove by mutableStateOf(false)
    var memoryEnabled by mutableStateOf(true)
    var visibleToasts by mutableStateOf(LToastVariant.entries.toSet())
    var chipVisible by mutableStateOf(true)
    var selectedTab by mutableStateOf("translation")
    var selectedLocale by mutableStateOf("fr")
    var query by mutableStateOf("")
    var menuExpanded by mutableStateOf(false)
    var entryMenuExpanded by mutableStateOf(false)
    var showMachineOutput by mutableStateOf(true)
    var lastMenuAction by mutableStateOf("No action selected") // i18n-ignore
    var modalSize by mutableStateOf<LModalSize?>(null)
    var confirmationOpen by mutableStateOf(false)
    var notifyTranslators by mutableStateOf(true)
    var selectedTags by mutableStateOf(setOf("checkout"))
    var selectedRows by mutableStateOf(setOf("checkout.payment"))
    var disclosureExpanded by mutableStateOf(true)
    var secondDisclosureExpanded by mutableStateOf(false)
    var denseAlertVisible by mutableStateOf(true)
    var stepIndex by mutableStateOf(1)
}

private data class AlertSample(val variant: LAlertVariant, val title: String, val description: String)
private data class TranslationRow(
    val key: String,
    val translation: String,
    val status: String,
    val variant: LBadgeVariant,
    val strings: Int,
)
private typealias Notify = (String, LToastVariant) -> Unit

private fun fillWrapModifier(): Modifier = Modifier
    .width(100.percent)
    .gap(Space.MD)
    .flexWrap(FlexWrap.Wrap)
    .styleModifier { property("justify-content", "space-between") }

private fun wideModifier(): Modifier = Modifier.styleModifier { property("grid-column", "1 / -1") }
private fun label(name: String): String = name.lowercase().replaceFirstChar { it.uppercase() }

/**
 * Specimen copy for the five toast variants, and deliberately not translated.
 *
 * `/ds` is the internal showcase, and these sentences are fixtures chosen to show what each variant
 * is *for* — "Importing app_en.arb" is a filename, not a message anybody receives. Putting them in
 * the catalogue would hand a translator five strings that no reader will ever meet and that would
 * stop illustrating anything the moment they were translated well. i18n-ignore
 */
private fun toastCopy(variant: LToastVariant): String = when (variant) {
    LToastVariant.NEUTRAL -> "Draft saved locally" // i18n-ignore
    LToastVariant.INFO -> "Importing app_en.arb" // i18n-ignore
    LToastVariant.SUCCESS -> "French locale published" // i18n-ignore
    LToastVariant.WARNING -> "18 strings need review" // i18n-ignore
    LToastVariant.DANGER -> "Upload failed validation" // i18n-ignore
}
